// extracted by mini-css-extract-plugin
module.exports = {"container":"modal_scrollable_footer-module__container--LQk3q"};